import { render, staticRenderFns } from "./Page_3.vue?vue&type=template&id=27d0c14e&"
import script from "./Page_3.vue?vue&type=script&lang=js&"
export * from "./Page_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports